import React from 'react'

const index = () => {
  return (
    <div>Wolfy Leads</div>
  )
}

export default index